/**
 * Instrumentation entry point names
 */
export const instrumentationEntryPoints = {
    TeamPage: "TeamPage",
    Schedule: "Schedule"
};
